import React from 'react'

export const Loader = () => {
    return (
        <span className="loader"></span>
    )
}
